import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PrivacyPolicyBody from './PrivacyPolicyBody';
import '../../styles/Common.css';

const backButtonStyle = {
  marginBottom: '20px',
  padding: '8px 16px',
  background: 'none',
  border: '1px solid #ddd',
  borderRadius: '20px',
  cursor: 'pointer',
  color: '#666',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container" style={{ padding: '40px 20px', maxWidth: '1000px', margin: '0 auto' }}>
      <button type="button" onClick={() => navigate('/')} style={backButtonStyle}>
        ← На главную
      </button>

      <div
        className="privacy-policy-content"
        style={{ background: '#fff', padding: '40px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}
      >
        <h1 style={{ marginBottom: '30px', fontSize: '2rem' }}>
          Политика в отношении обработки персональных данных на интернет-сайте
        </h1>
        <PrivacyPolicyBody />
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
